import React, { useState, useEffect } from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'src/utils/Http';
import { optionStyles, locale } from '../customize';
import { checkNewPath, checkDashboardsPath, checkShowListPath } from './target/setInfo'

export default function SetEmployeeInfo({ cookie, setTutorialStep3 }) {
    const { run, stepIndex, tourCompleted, type, employeeId } = cookie
    const { t } = useTranslation()
    const [load, setload] = useState(false)

    useEffect(() => {
        if (stepIndex == 1) {
            setTimeout(() => {
                setload(true)
            }, 2000)
        }
        else {
            setload(true)
        }
    }, [])

    const step = [
        {
            target: checkDashboardsPath('#employees.Setup__item--1ANJP'),
            content: t('features.GuideTour.Employees.SetInfoStep.0'),
            disableBeacon: true,
            placement: 'auto',
        },
        {
            target: checkShowListPath('.m-table-list tr:nth-child(2)'),
            content: t('features.GuideTour.Employees.SetInfoStep.1'),
            placement: 'auto',
        },
        {
            target: checkNewPath('.Form__box--1lDzq'),
            content: t('features.GuideTour.Employees.SetInfoStep.2'),
            placement: 'auto',
        },
        {
            target: checkNewPath('div.Form__boxMain--1CHRX div:nth-child(11)'),
            content: t('features.GuideTour.Employees.SetInfoStep.3'),
            placement: 'auto',
        },
        {
            target: checkNewPath('.u-ta-c.u-mt30 div:nth-child(2)'),
            content: t('features.GuideTour.Employees.SetInfoStep.4'),
            placement: 'auto',
        }
    ];

    const setStepIndex = (newIndex, id) => {
        setTutorialStep3({ run, stepIndex: newIndex, tourCompleted, type, employeeId: id ? id : employeeId })

    }
    const setTourCompleted = () => {
        setTutorialStep3({ run: false, stepIndex: 0, tourCompleted, type, employeeId })
    }
    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;
        const newIndex = index + (action === 'prev' ? -1 : 1);
        if (action === 'skip') {
            setTourCompleted()
        }
        else if (type === 'step:after' && index === 0) {
            redirectTo('/employees')
            setStepIndex(newIndex)

        }
        else if (type === 'step:after' && index === 1) {
            setStepIndex(newIndex)
            if (action === 'next') {
                document.getElementsByTagName('table')[0].children[1].children[1].click()//.children[0].key
            }
            action === 'prev' && redirectTo('/dashboards')
        }
        else if (type === 'step:after' && index === 2) {
            const employeeId = window.location.search.split('=')[1] // exployee_id=000
            setStepIndex(newIndex, employeeId)
            action === 'prev' && redirectTo('/employees')
        }
        else if (type === 'step:after' && index === 3) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 4) {
            action === 'prev' && setStepIndex(newIndex)
        }
    };

    return (
        <Joyride
            steps={step}
            run={run}
            stepIndex={stepIndex}
            callback={handleCallback}
            styles={optionStyles}
            locale={locale(t)}
            continuous
            scrollToFirstStep
            hideCloseButton
            showProgress
            showSkipButton
            disableOverlayClose
        />
    )
}
